import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Award,
    BadgeCheck,
    BookOpen,
    ChartLine,
    Clapperboard,
    Globe,
    Handshake,
    History,
    Info,
    LayoutDashboard,
    MessageSquareWarning,
    Share2,
    TicketPercent,
    UserPlus,
    Users,
    Activity,
} from 'lucide-react';
import { API_SRUDENT_URL } from '../../constants';
import AppSidebar from '../layout/AppSidebar/AppSidebar';

const SuperAdminSidebar = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const [studentAbout, setStudentAbout] = useState(false)
    const isIifaActive = ["/certificate", "/about", "/partners", "/social-media"].includes(location.pathname);
    const handleView = () => {
        setStudentAbout(x => !x)
    }
    const handleLogout = () => {
        localStorage.removeItem("admin_token");
        localStorage.removeItem("role");
        navigate("/login"); // Login sahifasiga yo‘naltirish
        window.location.reload(); // Role va tokenni to‘g‘ri yangilash uchun refresh
    };

    // Bandlar, path'lar va matnlar avvalgidek; faqat guruhlarga ajratilgan.
    // "social-media" — avvalgidek boshida "/" siz (nisbiy path).
    const groups = [
        {
            label: "Asosiy",
            items: [
                { to: "/", label: "Dashboard", icon: LayoutDashboard },
                { to: "/sales", label: "Sales", icon: ChartLine },
                { to: "/students", label: "Students", icon: Users },
                { to: "/learning-analytics", label: "Learning analytics", icon: Activity },
            ],
        },
        {
            label: "Ta'lim",
            items: [
                { to: "/courses", label: "Courses", icon: BookOpen },
                { to: "/certificate-holders", label: "Certificate holders", icon: Award },
                { to: "/promo-code", label: "Promo Code", icon: TicketPercent },
            ],
        },
        {
            label: "Video",
            items: [
                { to: "/new-lesson", label: "Video generate", icon: Clapperboard },
                { to: "/history", label: "Video generating history", icon: History },
            ],
        },
        {
            label: "Boshqaruv",
            items: [
                { to: "/new-employee", label: "Add Staff", icon: UserPlus },
            ],
        },
        {
            label: "IIFA UZ sayt",
            icon: Globe,
            collapsible: true,
            open: studentAbout,
            onToggle: handleView,
            active: isIifaActive,
            items: [
                { to: "/notifications/student-complaints" || "/notifications/teacher-complaints", label: "Complaints", icon: MessageSquareWarning, onClick: handleView },
                { to: "/about", label: "About", icon: Info, onClick: handleView },
                { to: "/partners", label: "Partners", icon: Handshake, onClick: handleView },
                { to: "social-media", label: "Social Networks", icon: Share2, onClick: handleView },
                { to: "/certificate", label: "Certificate", icon: BadgeCheck, onClick: handleView },
            ],
        },
    ];

    return <AppSidebar groups={groups} onLogout={handleLogout} />;
}

export default SuperAdminSidebar;
